import { Environment } from './environment.model';

export const environment: Environment = {
  name: 'prod',
  production: true,
  settings: {
    hmr: false,
    api: {
      url: '',
    },
    manager: {
      website: {
        url: '',
      },
    },
    website: {
      url: '',
    },
    keycloak: {
      config: {
        realm: '',
        url: '',
        sslRequired: 'external',
        clientId: '',
        publicClient: true,
        useResourceRoleMappings: true,
        confidentialPort: 0,
      },
      initOptions: {
        onLoad: 'check-sso',
      },
      enableBearerInterceptor: true,
    },
    sentry: {
      dsn: '',
    },
  },
};
